import React, { useState } from "react";
import "./ModalBank.scss";
import Notify from "../../../../../component/Notify/Notify";
import { Link } from "react-router-dom";

const ModalBank = ({ onClose, bankData }) => {
  const [notification, setNotification] = useState("");

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setNotification("คัดลอกแล้ว");
  };

  return (
    <div className="modalbank-wrapper">
      {notification && (
        <Notify
          message={notification}
          setcontent={setNotification}
          type="success"
        />
      )}

      <div className="modalbank">
        {/* Header */}
        <div className="modalbank-header">
          <div>
            <span className="modalbank-title">ข้อมูลการฝากเงิน</span>
            <p className="modalbank-subtitle">
              กรุณาตรวจสอบข้อมูลก่อนทำรายการ
            </p>
          </div>

          <button
            className="modalbank-close-btn"
            onClick={onClose}
            type="button"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="modalbank-body">
          <div className="modalbank-section-title">
            กรุณาโอนเงินไปยังบัญชีธนาคารต่อไปนี้
          </div>

          <div className="modalbank-content">
            {/* Bank information */}
            <div className="left-content">
              <div className="bank-info">
                <div className="bank-header">
                  <div className="bank-logo">
                    <img
                      className="bank-icon"
                      src="/logobank.png?v=2026"
                      alt={bankData.bank_name}
                    />
                  </div>

                  <div className="bank-name">
                    <span>ธนาคาร</span>
                    <strong>KBank (Kasikornbank)</strong>
                  </div>
                </div>

                <div className="info-list">
                  <div className="info-item">
                    <span className="label">เลขที่บัญชี</span>

                    <div className="info-value">
                      <span className="text">
                        1771799902
                      </span>

                      <button
                        type="button"
                        className="copy-button"
                        onClick={() =>
                          copyToClipboard(bankData.bank_account)
                        }
                      >
                        <img
                          src="/copy.png"
                          className="icon-copy"
                          alt="Copy"
                        />
                      </button>
                    </div>
                  </div>

                  <div className="info-item">
                    <span className="label">ชื่อบัญชี</span>

                    <div className="info-value">
                      <span className="text">
                        หจก. ค้ำคูณอาหารสัตว์
                      </span>

                      <button
                        type="button"
                        className="copy-button"
                        onClick={() =>
                          copyToClipboard(
                            bankData.bank_account_name
                          )
                        }
                      >
                        <img
                          src="/copy.png"
                          className="icon-copy"
                          alt="Copy"
                        />
                      </button>
                    </div>
                  </div>

                  <div className="info-item amount-row">
                    <span className="label">จำนวนเงิน</span>

                    <div className="info-value">
                      <span className="text amount">
                        {Number(
                          bankData.amount * 1
                        ).toLocaleString()}{" "}
                        THB
                      </span>
                    </div>
                  </div>

                  {/* <div className="info-item">
                    <span className="label">รายละเอียด</span>

                    <div className="info-value">
                      <span className="text code">
                        {bankData.code}
                      </span>

                      <button
                        type="button"
                        className="copy-button"
                        onClick={() =>
                          copyToClipboard(bankData.code)
                        }
                      >
                        <img
                          src="/copy.png"
                          className="icon-copy"
                          alt="Copy"
                        />
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* QR */}
            {/* <div className="right-content">
              <p className="qr-title">
                สแกน QR Code เพื่อชำระเงิน
              </p>

              <div className="qr-box">
                <img
                  src="/qrck.png"
                  alt="QR code"
                />
              </div>

              <p className="qr-description">
                สแกน QR Code เพื่อชำระเงินอย่างรวดเร็ว
                หากมีข้อสงสัย กรุณาติดต่อฝ่ายบริการลูกค้า
              </p>
            </div> */}
          </div>

          {/* Actions */}
          <div className="modalbank-actions">
            <button
              className="btn-default"
              onClick={onClose}
              type="button"
            >
              ยกเลิก
            </button>

            <Link
              to="/accounttk"
              state={{ tab: "history" }}
              className="confirm-link"
            >
              <button
                className="btn-primary"
                type="button"
              >
                ยืนยันการฝากเงิน
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalBank;